import { GENERATE_URL } from "@services/helpers/request";

const PREFIX_URL = "/Tks";

export const TKS_PREFIX_URL = PREFIX_URL;

export const GetAll = (options) =>
  GENERATE_URL(`${PREFIX_URL}/GetAll`, options);

export const Create = (options) =>
  GENERATE_URL(`${PREFIX_URL}/Create`, options);

export const GetById = (options) =>
  GENERATE_URL(`${PREFIX_URL}/GetById/:id`, options);

export const Calculate = (options) =>
  GENERATE_URL(`${PREFIX_URL}/Calculate`, options);

export const GetDeviceNames = (options) =>
  GENERATE_URL(`${PREFIX_URL}/GetDeviceNames`, options);

export const GetGrainNames = (options) =>
  GENERATE_URL(`${PREFIX_URL}/GetGrainNames`, options);

export const GetCapacityByDevice = (options) =>
  GENERATE_URL(`${PREFIX_URL}/GetCapacityByDevice`, options);

export const Delete = (options) =>
  GENERATE_URL(`${PREFIX_URL}/Delete/:id`, options);

export default {
  GetAll,
  Create,
  GetById,
  Calculate,
  GetDeviceNames,
  GetGrainNames,
  GetCapacityByDevice,
  Delete,
};
